import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navigation-bar",
  ref: "navbar"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "navigation-bar__line-top" }, null, -1)
const _hoisted_3 = {
  class: "navigation-bar__menu",
  ref: "navbarMenu"
}
const _hoisted_4 = { class: "navigation-bar__logo" }
const _hoisted_5 = { class: "min-logo-wrapper" }
const _hoisted_6 = { class: "navigation__nav-items" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "navigation-bar__line-bottom" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactPopupButton = _resolveComponent("ContactPopupButton")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _renderSlot(_ctx.$slots, "language-selector"),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "minified-logo")
        ]),
        _renderSlot(_ctx.$slots, "logo")
      ]),
      _createElementVNode("nav", {
        class: _normalizeClass(["navigation", [
                _ctx.isMobileMenuOpen ? 'navigation--active' : '',
                _ctx.isSmallScreenSize ? 'navigation--mobile' : 'navigation--desktop']])
      }, [
        _createElementVNode("ul", _hoisted_6, [
          _renderSlot(_ctx.$slots, "anchorlinks", { onClick: _ctx.handleScrollToView }),
          _createElementVNode("li", null, [
            _createVNode(_component_ContactPopupButton, {
              class: "navigation__contact-button",
              "email-address": _ctx.contactEmailAddress,
              "contact-completed-image": _ctx.contactCompletedImage,
              "instagram-handle": _ctx.instagramHandle,
              "facebook-handle": _ctx.facebookHandle,
              "linked-in-handle": _ctx.linkedInHandle,
              "contact-form-terms-conditions-link": _ctx.contactFormTermsConditionsLink,
              "contact-form-terms-conditions-link-target": _ctx.contactFormTermsConditionsLinkTarget,
              "content-id": _ctx.contentId
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('heuver-albourgh.areas.navigation.buttonContact')), 1)
              ]),
              _: 1
            }, 8, ["email-address", "contact-completed-image", "instagram-handle", "facebook-handle", "linked-in-handle", "contact-form-terms-conditions-link", "contact-form-terms-conditions-link-target", "content-id"])
          ]),
          _renderSlot(_ctx.$slots, "language-selector")
        ])
      ], 2),
      _withDirectives(_createElementVNode("button", {
        class: _normalizeClass(["navigation-bar__menu-button", _ctx.isMobileMenuOpen ? 'navigation-bar__menu-button--active' : '']),
        "aria-label": "Navigation menu button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMobileMenu && _ctx.handleMobileMenu(...args)))
      }, null, 2), [
        [_vShow, _ctx.isSmallScreenSize]
      ])
    ], 512),
    _hoisted_7
  ], 512))
}